import { Box, SxProps, Theme } from '@mui/material';

const Logo = (props?: { sx?: SxProps<Theme> }) => {
  return (
    <Box width="227px" sx={props?.sx}>
      <img width="100%" src="/assets/logo.png" style={{ maxWidth: '227px' }} />
    </Box>
  );
};

export default Logo;
